// Paleta das salas pessoais.
//
// Fechada de proposito, em vez de seletor de cor livre: no tema escuro do
// portal um hex qualquer pode virar cinza sobre cinza e sumir com a sala. As
// chaves aqui precisam bater com a constante CORES do salaService — o backend
// valida contra ela.

export const CORES_DA_SALA = {
  teal:     { nome: 'Teal',     forte: '#2A8A9C', suave: 'rgba(42, 138, 156, 0.16)' },
  indigo:   { nome: 'Indigo',   forte: '#5C6BC0', suave: 'rgba(92, 107, 192, 0.16)' },
  violeta:  { nome: 'Violeta',  forte: '#9575CD', suave: 'rgba(149, 117, 205, 0.16)' },
  rosa:     { nome: 'Rosa',     forte: '#D8608F', suave: 'rgba(216, 96, 143, 0.16)' },
  ambar:    { nome: 'Ambar',    forte: '#FE8D25', suave: 'rgba(254, 141, 37, 0.16)' },
  verde:    { nome: 'Verde',    forte: '#4CB553', suave: 'rgba(76, 181, 83, 0.16)' },
  vermelho: { nome: 'Vermelho', forte: '#E05252', suave: 'rgba(224, 82, 82, 0.16)' },
  cinza:    { nome: 'Cinza',    forte: '#8FA5AC', suave: 'rgba(143, 165, 172, 0.16)' },
};

export const COR_PADRAO = 'teal';

export function corDaSala(chave) {
  return CORES_DA_SALA[chave] || CORES_DA_SALA[COR_PADRAO];
}

// Variaveis CSS para o componente pintar borda, brilho e chip sem precisar
// saber de qual cor se trata.
export function estiloDaCor(chave) {
  if (!chave || !CORES_DA_SALA[chave]) return undefined;
  const cor = CORES_DA_SALA[chave];
  return { '--sala-cor': cor.forte, '--sala-cor-suave': cor.suave };
}
